import { render, staticRenderFns } from "./JpFooter.vue?vue&type=template&id=1dd9331c&scoped=true"
var script = {}
import style0 from "./JpFooter.vue?vue&type=style&index=0&id=1dd9331c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9331c",
  null
  
)

export default component.exports